/* eslint-disable @typescript-eslint/no-explicit-any */
import { Reducer, Store } from 'redux';
import { createRootReducer } from './configureStore';
import rootReducer from './rootReducer';

let store: Store;

export function setStore(currentStore: Store) {
  store = currentStore;
}

const asyncReducers: { [key: string]: Reducer<any> } = {};

/**
 *
 * Use this function in lazy loaded screen to inject new reducer into the store and apply lazy loading also on state management.
 * You do not need to put the reducer inside the root reducers map.
 * !IMPORTANT
 * If you lazy load the reducer you need to be sure that is is loaded before using any selector or similar that uses the state
 *
 * If the key has already been injected it is skipped so it is safe to force the same reducer injection in any point
 *
 * If the name conflicts with a static reducer it throws an error
 *
 * @param key state key
 * @param asyncReducer reducer to attach
 */
export function injectReducer<S>(key: string, asyncReducer: Reducer<S, any>) {
  if (key in rootReducer) {
    throw new Error(
      `Async Reducer key conflict with an already existing ${key}, choose another name`,
    );
  }
  if (!store) {
    throw new Error('Store not initialized');
  }
  if (!(key in asyncReducer)) {
    asyncReducers[key] = asyncReducer;

    store.replaceReducer(
      createRootReducer({
        ...rootReducer,
        ...asyncReducers,
      }),
    );
  }
}
